import React,{useState} from "react";
import {
  Button,
  Card,
  Grid,
  Dimmer,
  Loader,
} from "semantic-ui-react";
import numeral from "numeral";
import { toast } from "react-toastify";

const Invoice = (props) => {
  const [loading, setLoading] = useState(false);
  const _makeRequest = () => {
    try {
      setLoading(true);
      props.onSuccess({ reference: "INVOICED" },props.paymentMode,props.total);
      props.toggleModal(false);
    } catch (error) {
      setLoading(false);
      toast.warn("Transaction failed");

      console.log("error", error);
    }
  };

  return (
    <div>
      {loading && (
        <Dimmer active inverted>
          <Loader />
        </Dimmer>
      )}

      <Grid centered style={{ marginTop: 10, marginBottom: 10 }}>
        <Card centered>
          <Card.Content>
            <Card.Meta>Confirm Reserved Payment</Card.Meta>
          </Card.Content>
          <Card.Content>
            <Grid columns={2} textAlign="left">
              <Grid.Row>
                <Grid.Column>Request Amount</Grid.Column>
                <Grid.Column>
                  <b>₦{numeral(props.total).format("0,0")}</b>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Card.Content>
          <Card.Content>
            <Button
              disabled={loading}
              positive
              onClick={_makeRequest}
              style={{ width: "100%" }}
            >
              Confirm Reserved Payment
            </Button>
          </Card.Content>
        </Card>
      </Grid>
    </div>
  );
};

export default Invoice;
